<template>
  <div class="login-page">
    <div class="bloc-connexion">
      <div cols="12" class="bloc-connexion__content">
          <v-col class="image-placeholder">
              <h1 class="text text-uppercase display-2 font-weight-bold">
                Bienvenue sur
              </h1>
              <div>
                <v-img
                class="my-5"
                src="/static/images/logo-spideup-white.png"
                width="300"
              ></v-img>
              </div>
              <p class="text text-login">
                Bienvenue sur la plateforme SpideUp, votre solution de mesure
                et de création de trafic dans votre point de vente
              </p>
              <p class="text text-login">
                Le meilleur de l'intéraction mobile pour votre clilentèle !
              </p>
              <v-row class="footer">
                <v-img class="white--text pl-2 pb-1">1G-Link © 2023</v-img>
              </v-row>
          </v-col>

          <v-col class="login-params">
            <v-row class="text weight-bold size-xlarge mb-5">
              <strong>Réinitialisation du mot de passe</strong>
            </v-row>
            <v-row class="contact-bloc mb-7">
              Veuillez saisir votre adresse email ci-desous.<br />
              Nous vous enverrons les instructions pour créer<br />
              un nouveau mot de passe.<br />
            </v-row>
            <v-row class="d-flex flex-column mb-7">
              <LoginInput
                class="login pt-0 pl-0 mb-6"
                inputType="regular"
                placeholder="Entrez votre email"
                label="Identifiant"
                v-model="email"
              />

              <v-col cols="12" class="password my-6">
                <router-link class="forgot-pwd" to="login"
                  >Retourner à la page de connexion</router-link
                >
              </v-col>

              <v-col>
                <customButton
                  label="Réinitialiser"
                  btnType="connexion"
                  :elevation="0"
                  @click="sendPasswordRequest"
                />
              </v-col>
            </v-row>
          </v-col>
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
import TextInput from "@/components/input/textInput";
import CheckBox from "@/components/input/checkboxInput.vue";
import customButton from "@/components/buttons/customButton.vue";
import LoginInput from "@/components/input/loginInput";

export default {
  components: {
    CheckBox,
    TextInput,
    customButton,
    LoginInput,
  },
  props: {},
  data() {
    return {
      email: "",
    };
  },
  methods: {
    sendPasswordRequest() {
      this.$store.dispatch("auth/passwordResetRequest", {
        parameters: {
          email: this.email,
        },
        success: (response) => {
          this.$router.push({
            name: "PasswordResetConfirm",
            params: { email: this.email },
          });
        },
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.centering {
  overflow-wrap: break-word;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.left-wing {
  position: relative;
  background-image: url("../../assets/images/login-img.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-content: center;
  padding: 9%;
  &::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.25);
  }
}

.right-wing {
  background-color: white;
  padding: 9%;
  justify-content: center;
  align-content: center;
  .forgot-pwd {
    color: $grey-login-dark;
    background-color: white !important;
    text-transform: none !important;
  }
  .pwd-indicator-title {
    color: $grey-login-light;
  }
  .contact-bloc {
    color: $grey-login;
    .contact {
      color: $color-primary;
    }
  }
}

h1 {
  position: relative;
  color: #ffffff;
  font-size: 18px !important;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.2px;
}

.footer {
  position: absolute;
  top: 95%;
  left: 15%;
  transform: translate(-50%, -50%);
}

.password {
  display: flex;
  align-items: center;
  justify-content: end;
}

.label {
  font-size: 18px !important;
}
</style>